import { render, staticRenderFns } from "./StandartOrderPassiveStock.vue?vue&type=template&id=54cf634c&scoped=true"
import script from "./StandartOrderPassiveStock.vue?vue&type=script&lang=js"
export * from "./StandartOrderPassiveStock.vue?vue&type=script&lang=js"
import style0 from "./StandartOrderPassiveStock.vue?vue&type=style&index=0&id=54cf634c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cf634c",
  null
  
)

export default component.exports